import {
    Autocomplete,
    AutocompleteItem,
    Button,
} from "@nextui-org/react"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    NextUITable,
    VirtualizeAutoComplete,
} from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModValue } from "../../constants/enum"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useSelector } from "react-redux"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { useEffect, useMemo, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { calculateTotal } from "../../Utility/utility"
import { isMobile } from "react-device-detect"


const GenFasOrderSummary = () => {
    let { compCode, appType } = useSelector((state) => state.company)
    let [selectedParty, setSelectedParty] = useState("")
    let [selectedItemType, setSelectedItemType] = useState("")
    let [selectedProduct, setSelectedProduct] = useState("")
    const [filterItemType, setFilterItemType] = useState([])
    //let [data, setData] = useState([])

    const [filterDate, setFilterDate] = useState({
        start: null,
        end: null,
    })

    const { isLoading, isError: isErrorFetch, data: itemDetails = [] } = useFetchWithBody({
        url: apiRoute.salesorder.fetchMasterData,
        queryKey: "SalesMasterData",
        inputData: {
            compcode: compCode[0],//.join(","),
        }
    })

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modeSetting.getModSetting,
        queryKey: "fetchModSetting",
        inputData: {
            mod_name: ENUM_MOD_NAME.general
        }
    })
    const getTradeOf = (type) => {
        if (type && type != "") {
            return type.toLowerCase() == 'row material' ? 'Y' : 'C'
        }
        else
            return ""
    }
    useEffect(() => {
        //if(app)
        const ItemType = getModValue(ENUM_MOD_PARAMETER.generalSetting.AppItemType, modSetting)
        if (ItemType != "") {
            //const list=ItemType.split(","))
            const d = ItemType.split(",").map((ele) => ({ item_type: ele, key: getTradeOf(ele) }))
            setFilterItemType(d)
            setSelectedItemType('C')

        }
    }, [modSetting])
    const {
        isPending,
        isError,
        data = [],
        //data: salesOrderData = [],
        mutate: filterSales,
    } = usePost({
        url: apiRoute.salesorder.fetchGenfasOrder,
        queryKey: "SalesOrder",
    })
    const funSalesData = () => {
        filterSales({
            data: {
                compcode: compCode.join(","),
                fromdate: filterDate.start
                    ? new Date(filterDate.start).toISOString().split("T")[0]
                    : null,
                todate: filterDate.end
                    ? new Date(filterDate.end).toISOString().split("T")[0]
                    : null,

                partyid: selectedParty != null && selectedParty !== "" ? selectedParty : "",
                itemcode: selectedProduct != null && selectedProduct !== "" ? selectedProduct : "", //"F/13261",
                tradeof: selectedItemType !== "" ? selectedItemType : "", // "GRAY",
            },
        })
    }

    // useEffect(() => {
    //   setData(salesOrderData)
    // }, [salesOrderData])
    
    useEffect(() => {
        funSalesData()
    }, [])

    // const handleDataChange = ({ data, isFilter }) => {

    //   if (isFilter)
    //     setData(data)
    //   else{

    //     setData(salesOrderData)
    //   }
    // }


    let totalOrdQty = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Ord_Qty",
            }),
        [data]
    )
    let totalDelQty = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Desp_Qty",
            }),
        [data]
    )

    let totalBalQty = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Bal_Qty",
            }),
        [data]
    )
    let downloadDataFooter = {
        PartyName: "",
        Item_Code: "",
        Item_Desc: "",
        Ord_No: "",
        Ord_Date: "",
        Ord_Qty: "Total: " + totalOrdQty,
        Rate: "",
        Desp_Qty: "Total: " + totalDelQty,
        Bal_Qty: "Total: " + totalBalQty,
        BrokerName: "",
        Remark: "",
    }


    const handleResetFilter = () => {
        setSelectedParty("") //{ key: "", value: "" }
        setSelectedItemType("")
        setSelectedProduct("") //{ key: "", value: "" }
        setFilterDate({
            start: null,
            end: null,
        })
        /// funSalesData()
        filterSales({
            data: {
                compcode: compCode.join(","),
                fromdate: null,
                todate: null,
                partyid: "",
                itemcode: "", //"F/13261",
                tradeof: "C",
            },
        })
    }

    const handleFilter = () => {
        funSalesData()
    }


    const INITIAL_VISIBLE_COLUMNS = [
        "PartyName",
        "Item_Code",
        "Item_Desc",
        "Ord_No",
        "Ord_Date",
        "Ord_Qty",
        "Rate",
        "Desp_Qty",
        "Bal_Qty",
        "BrokerName",
        "Remark",
    ]
    const columns = [
        { name: "PARTY NAME", uid: "PartyName", sortable: true },

        {
            name: "ITEM CODE",
            uid: "Item_Code",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,

        },

        {
            name: "ITEM DESC",
            uid: "Item_Desc",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "ORDER NO.",
            uid: "Ord_No",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
        {
            name: "ORDER DATE",
            uid: "Ord_Date",
            type: COLUMN_TYPE.date,
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
        {
            name: "ORD.QTY",
            uid: "Ord_Qty",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalOrdQty,
            },
        },
        {
            name: "RATE",
            uid: "Rate",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
        {
            name: "DEL.QTY",
            uid: "Desp_Qty",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalDelQty,
            },
        },
        {
            name: "BAL.QTY",
            uid: "Bal_Qty",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalBalQty,
            },
        },
        {
            name: "Broker",
            uid: "BrokerName",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,

        },
        {
            name: "REMARK",
            uid: "Remark",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
    ]
    if (isPending) { return <LoadingCard /> }
    if (isError || isErrorFetch) { return <ErrorCard /> }
    return (
        <div>

            <MainContainer
                pageName="Sales Order Summary"
                info={[]}
                breadcrumbs={["Sales ", "Summary"]}
            >

                <div className="flex flex-wrap mb-2 bg-gray-10 gap-2 shadow p-3">

                    {/* date */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label={"Start Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={
                                filterDate.start
                                    ? dayjs(filterDate.start)
                                    : filterDate.start
                            }
                            onChange={(newValue) => {
                                setFilterDate((prev) => {
                                    return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                                })
                            }}
                            sx={{ width: "145px" }}
                            slotProps={{ textField: { size: "small" } }}
                        />
                        <DatePicker
                            label={"End Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={
                                filterDate.end ? dayjs(filterDate.end) : filterDate.end
                            }
                            onChange={(newValue) => {
                                setFilterDate((prev) => {
                                    return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                                })
                            }}
                            slotProps={{ textField: { size: "small" } }}
                            sx={{ width: "145px" }}
                        />
                    </LocalizationProvider>

                    <div className={` flex  items-center gap-2 ${isMobile ? "flex-wrap" : ""} `} >
                        <Autocomplete
                            size="sm"
                            name={"itemCode"}
                            label={"Item Name"}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder={"--Select--"}
                            className={`${isMobile ? "w-full" : "max-w-42"} `}
                            isClearable={true}
                            variant="bordered"
                            isVirtualized
                            defaultItems={
                                itemDetails && itemDetails.itemMaster
                                    ? itemDetails.itemMaster : []
                            }
                            onSelectionChange={setSelectedProduct}
                            selectedKey={selectedProduct}
                        >
                            {(list) => (
                                <AutocompleteItem

                                    key={list.Item_Code}
                                >
                                    {list.Item_CodeNDesc}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                        <Autocomplete
                            size="sm"
                            name={"partyId"}
                            label={"Party Name"}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder={"--Select--"}
                            className={`${isMobile ? "w-full" : "max-w-42"} `}
                            isClearable={true}
                            variant="bordered"
                            isVirtualized
                            defaultItems={
                                itemDetails && itemDetails.pitemMaster
                                    ? itemDetails.pitemMaster : []
                            }
                            onSelectionChange={setSelectedParty}
                            selectedKey={selectedParty}
                        >
                            {(list) => (
                                <AutocompleteItem

                                    key={list.Party_Id}
                                >
                                    {list.Party_Name}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    </div>
                    <Autocomplete
                        size="sm"
                        label="Item Type"
                        className="max-w-40"
                        defaultItems={filterItemType ? filterItemType : []}
                        selectedKey={selectedItemType}
                        onSelectionChange={setSelectedItemType}
                    >
                        {(item) => (
                            <AutocompleteItem key={item.key}>
                                {item.item_type}
                            </AutocompleteItem>
                        )}
                    </Autocomplete>

                    <Button
                        color="primary"
                        size="sm"
                        startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                        onPress={handleFilter}

                    >
                        Search
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faFilter} />}
                        onPress={handleResetFilter}
                    >
                        Reset
                    </Button>

                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    columns={columns}
                    exportColumns={columns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="SALES_ORDER"
                    showAdvanceFilter={false}
                    id="Ord_No"
                ></NextUITable>

            </MainContainer>
        </div>
    )
}
export default GenFasOrderSummary


